export type Change<T> = {
    readonly old: T;
    new?: T;
};

export const getChangeValue = <T>(desc: Change<T>) => desc.new ?? desc.old;
